@if (visible()) {
  <!-- Relatie / Composiet details: de vier relatie-blokken. -->
  <h4 class="hd-composite-sections__subsection-title">{{ detailsTitle() }}</h4>

  @for (block of blocks(); track block.key) {
    <section class="hd-composite-sections__section">
      <!-- Cheat-sheet-stijl kop: kaartkleur + icoon, titel + korte uitleg (geen uitklap). -->
      <div class="hd-composite-sections__header" [style.--section-color]="block.color">
        <i class="fas fa-{{ block.faIcon }} hd-composite-sections__header-icon" aria-hidden="true"></i>
        <span class="hd-composite-sections__header-text">
          <span class="hd-composite-sections__title">{{ block.title }}</span>
          <span class="hd-composite-sections__brings">{{ block.brings }}</span>
        </span>
        <button type="button" class="hd-composite-sections__header-info"
                [attr.aria-label]="relationInfoLabel()" [title]="relationInfoLabel()"
                (click)="requestRelationInfo(block.key, $event)">
          <i class="fas fa-circle-info" aria-hidden="true"></i>
        </button>
      </div>

      @for (entry of block.channels; track entry.key) {
        <div class="hd-composite-sections__item">
          <hd-channel-list-item
            [channelKey]="entry.channel.channelKey"
            [cycleGates]="entry.channel.gates"
            [accent]="{ color: block.color, faIcon: block.faIcon }"
            [annotation]="entry.note"
            [showBothSourceGlyphs]="true"
            expandable
            [expanded]="items.isExpanded(entry.key)"
            (expandToggled)="items.toggle(entry.key)"
            (gateInfoRequested)="gateInfoRequested.emit($event)"
            (channelInfoRequested)="channelInfoRequested.emit($event)"
          />
          <!-- I Tjing-kaarten van beide personen op het kanaal: default dicht, pas gebouwd bij uitklappen. -->
          <hd-cycle-cards [slots]="entry.cards" [visible]="items.isExpanded(entry.key)" />
        </div>
      }
    </section>
  }

  <!-- Niet-zelf center thema's per persoon, in twee kolommen (1 = blauw, 2 = groen). -->
  <h4 class="hd-composite-sections__subsection-title hd-composite-sections__subsection-title--with-info">
    <span>{{ centersTitle() }}</span>
    <button type="button" class="hd-composite-sections__subsection-info"
            [attr.aria-label]="relationInfoLabel()" [title]="relationInfoLabel()"
            (click)="requestRelationInfo('centers', $event)">
      <i class="fas fa-circle-info" aria-hidden="true"></i>
    </button>
  </h4>
  <div class="hd-composite-sections__persons">
    @for (person of personCenters(); track person.name) {
      <div class="hd-composite-sections__person">
        <div class="hd-composite-sections__person-name" [style.color]="person.color">{{ person.name }}</div>
        @for (conditioned of person.centers; track conditioned.center) {
          <hd-cycle-conditioned-center-block
            [center]="conditioned.center"
            [label]="conditioned.label"
            [text]="conditioned.text"
            [causes]="conditioned.causes"
            clickable
            (centerInfoRequested)="centerInfoRequested.emit($event)"
            (gateInfoRequested)="gateInfoRequested.emit($event)"
          />
        } @empty {
          <div class="hd-composite-sections__person-empty">—</div>
        }
      </div>
    }
  </div>
}
